import {
    ActionIcon,
    Anchor,
    Box,
    Burger,
    Button,
    Container,
    Group,
    NumberFormatter,
    Stack,
    Text,
    Tooltip,
} from '@mantine/core';

import Logo from '../misc/Logo';
import UserBillingModal from '../../modals/billing/UserBillingModal';
import UserDropdown from '../userDropdown/UserDropdown';
import classes from './Header.module.css';
import { useAuthStore } from '../../../store';
import { useDisclosure } from '@mantine/hooks';

const Header = ({ showDropdown = true, toggleNavbar }) => {
    const [opened, { toggle }] = useDisclosure(false);

    const handleToggle = () => {
        if (toggleNavbar) {
            toggleNavbar();
        }
        toggle();
    };

    return (
        <Container
            className={classes.header}
            h={'100%'}
            fluid>
            <Group
                className={classes.mainSection}
                justify='space-between'>
                <Logo />
                <Group
                    gap={'xs'}
                    align={'center'}
                    justify={'flex-end'}>
                    {showDropdown ? <BillingSection /> : null}
                    {showDropdown ? <UserDropdown /> : null}
                </Group>
                <Burger
                    opened={opened}
                    onClick={handleToggle}
                    hiddenFrom='xs'
                    size='sm'
                />
            </Group>
        </Container>
    );
};
export default Header;

const BillingSection = ({}) => {
    const userProfile = useAuthStore((state) => state.userProfile);
    const [modalOpen, { open: openModal, close: closeModal }] = useDisclosure();

    return (
        <>
            <Stack
                align={'center'}
                gap={0}>
                <Text size={'sm'}>Balance</Text>
                <Anchor
                    component={'button'}
                    size={'sm'}
                    variant={'transparent'}
                    onClick={openModal}>
                    <NumberFormatter
                        prefix='$'
                        decimalScale={2}
                        fixedDecimalScale={2}
                        value={userProfile?.balance || 0}
                    />
                </Anchor>
            </Stack>
            <UserBillingModal
                opened={modalOpen}
                close={closeModal}
            />
        </>
    );
};
